import { IFormSchema } from '@publishing-engine/domain/models/form-schema';
import { ComponentName, ExtractType } from '@publishing-engine/domain/types';
import { FormFieldDefinition } from '@publishing-engine/domain/types/article';

type IReviewForms = {
  firstAssessment: IFormSchema;
  revisionAssessment?: IFormSchema;
};

/**
 * Wrapper around review formSchemas (at the moment firstAssessment, later revisionAssessment)
 * to provide convenience access around shared and unique formFieldDefinitions.
 */
export class ReviewFormFields {
  private forms: IReviewForms;

  constructor(firstAssessment: IFormSchema, revisionAssessment?: IFormSchema) {
    this.forms = {
      firstAssessment
    };

    if (revisionAssessment) {
      this.forms.revisionAssessment = revisionAssessment;
    }
  }

  hasField<CN extends ComponentName>(componentName: CN) {
    return Object.values(this.forms).reduce((found, form) => {
      if (found) {
        return true;
      }
      return form.formFields?.some(cfg => cfg.name === componentName) ?? false;
    }, false);
  }

  getFieldConfig<CN extends ComponentName>(componentName: CN) {
    const fieldConfig = Object.values(this.forms).reduce(
      (fieldConfig: FormFieldDefinition | null, form) => {
        if (fieldConfig) {
          return fieldConfig;
        }
        return (
          form?.formFields?.find(cfg => cfg.name === componentName) ?? null
        );
      },
      null
    );

    return fieldConfig as ExtractType<FormFieldDefinition, CN> | null;
  }
}
